/**
 * @file     findTenantsFlow.ts
 * @readme   ../../CLAUDE.md
 * @purpose  English strings for the Find Tenants (landlord) lead flow: intro, steps, and confirmation copy.
 */
export const findTenantsFlow = {
  intro: {
    eyebrow: 'Find tenants',
    title: 'Find tenants without full property management',
    description:
      'Get help pricing your rental, finding good tenants, and setting up the lease. This is not property management.'
  },
  capture: {
    title: 'Get a tenant placement plan',
    subtitle:
      'Share the property basics and your timing to get a next step.',
    submit: 'Send request'
  }
} as const;
